module.exports = __webpack_public_path__ + "static/media/119.9e96b995.jpg";